'use client';

import { useNotifications } from '@/hooks/useNotifications';
import { createContext, ReactNode, useContext } from 'react';

interface NotificationContextType {
  permission: NotificationPermission;
  token: string | null;
  tokenId: string | null;
  isLoading: boolean;
  isDisabled: boolean;
  requestPermission: () => Promise<string | null>;
  removePermission: () => Promise<boolean>;
  resetState: () => void;
  forceSaveToken: () => Promise<boolean>;
}

const NotificationContext = createContext<NotificationContextType | undefined>(undefined);

interface NotificationProviderProps {
  children: ReactNode;
}

export function NotificationProvider({ children }: NotificationProviderProps) {
  const notifications = useNotifications();

  return <NotificationContext.Provider value={notifications}>{children}</NotificationContext.Provider>;
}

export function useNotificationContext() {
  const context = useContext(NotificationContext);
  if (context === undefined) {
    throw new Error('useNotificationContext must be used within a NotificationProvider');
  }
  return context;
}
